<template>
   <v-card flat>
    <v-card-title>GET - /api/addresses/{addressId}</v-card-title>
    <hr />
    <v-card-text>
      <v-simple-table class="table">
        <template v-slot:default>
          <tbody>
            <tr>
              <td>HTTP Method :</td>
              <td>GET</td>
            </tr>
            <tr>
              <td>URL :</td>
              <td>
                <a :href="url + restUrl" target="_blank">{{url +restUrl}}</a>
              </td>
            </tr>
            <tr>
              <td>Description :</td>
              <td>This function allows you to get an address based on the AddressId and fields. It gives the response based on the request parameters.</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-title>Request Parameters:</v-card-title>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Parameter Name</th>
              <th class="text-left">Description</th>
              <th class="text-left">Parameter Type</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>AddressId</td>
              <td>AddressId value to get address</td>
              <td>path</td>
            </tr>
            <tr>
              <td>fields</td>
              <td>AddressId, postcode ,Address,Additional, misc.Any child node of above</td>
              <td>query</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-title>AddressId:</v-card-title>
    <v-card-text>
      <ul>
        <li>
          AddressId value is mandatory. AddressId should be valid otherwise its throws an error
          “Message: The request is invalid.”
        </li>
      </ul>
    </v-card-text>

    <v-card-title>Fields:</v-card-title>
    <v-card-text>
      <ul>
        <li>The top level fields values are AddressId, Postcode, Address, Additional, Misc</li>
        <li>You can send fields values as a top level fields child node.</li>
        <li>e.g.</li>
        <pre>
        <code v-html="fieldJson" />
        </pre>
        <li>You can send an “OrganisationName” as a fields value.</li>

        <li>Fields parameter can accept a single value as well as multiple values separated by “,”</li>
        <li>Whenever we are pass fields value as query parameter, In JSON response contains that parameter value; other fields parameter value is Empty.</li>
      </ul>
    </v-card-text>

    <v-card-text>Below is the JSON Response for AddressId as “32171910-b000-0000-0000-000003919038” and fields as “misc” -</v-card-text>

    <v-card-title>JSON Response:</v-card-title>
    <v-card-text>
      <pre>
      <code v-html="jsonResponse" />
      </pre>
    </v-card-text>
    <br/>
  </v-card>
</template>

<script>
export default {
  name: "MainPage",
  data: () => ({
    url: process.env.VUE_APP_BASE_URL,
    restUrl: "addresses/{addressId}?fields",
    fieldJson: {
      Address: {
        OrganisationName: "APPNOVATION TECHNOLOGIES LTD",
        DepartmentName: "",
        PoBoxNumber: "",
        SubBuilding: "",
        Building: "READING BRIDGE HOUSE",
        DependentThoroughfare: "",
        Thoroughfare: "READING BRIDGE",
        DoubleDependentLocality: "",
        DependentLocality: "",
        PostTown: "READING",
        Postcode: "RG1 8LS",
        County: "OXFORDSHIRE"
      }
    },
    jsonResponse: [
      {
        AddressId: "32171910-b000-0000-0000-000003919038",
        Postcode: "RG1 8LS",
        Address: {},
        Additional: {},
        Misc: {
          AddressStatus: "L",
          NumberHouseholds: "1",
          UDPRN: "54811439",
          Building_Number: "0",
          Building_Name: "READING BRIDGE HOUSE"
        }
      }
    ],
  })
};
</script>
